import { columnSettings, tableWidth } from "./report-template-setting";
import { format } from "date-fns";

const settings = {};
for (let columnSetting of columnSettings) {
  settings[columnSetting.field] = columnSetting;
}

const ReportTemplateDetail = (props) => {
  const {
    mykey,
    no,
    tanggal_transaksi,
    data_kendaraan,
    keterangan,
    jumlah,
    harga_per_liter,
    total_harga,
    speedo_akhir,
  } = props;

  const numberFormat = (number) => {
    // not currency
    return new Intl.NumberFormat("id-ID", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(number);
  };

  return (
    <tr
      key={mykey}
      className={`row-start-start ${tableWidth} text-sm text-slate-700 !items-stretch`}
    >
      <td
        className={`${settings["no"].layout} ${settings["no"].width} border-zinc-300 border border-t-0  px-2 pt-2 pb-1 `}
      >
        {no}
      </td>

      <td
        className={`${settings["data_kendaraan"].layout} ${settings["data_kendaraan"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
      >
        {data_kendaraan.nomor_polisi}
      </td>

      <td
        className={`${settings["tanggal_transaksi"].layout} ${settings["tanggal_transaksi"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1`}
      >
        {tanggal_transaksi
          ? format(
              new Date(tanggal_transaksi),
              settings["tanggal_transaksi"].format
            )
          : "-"}
      </td>

      <td
        className={`${settings["jumlah"].layout} ${settings["jumlah"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
      >
        {numberFormat(jumlah)}
      </td>

      <td
        className={`${settings["harga_per_liter"].layout} ${settings["harga_per_liter"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
      >
        {numberFormat(harga_per_liter)}
      </td>

      <td
        className={`${settings["total_harga"].layout} ${settings["total_harga"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
      >
        {numberFormat(total_harga)}
      </td>

      <td
        className={`${settings["speedo_akhir"].layout} ${settings["speedo_akhir"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
      >
        {speedo_akhir}
      </td>
    </tr>
  );
};

export default ReportTemplateDetail;
